<template>
  <div class="ec-calculation-info">
    <div class="ec-calculation-name-wrapper">{{ $t('calculation_info.active_calculation') }}:<span 
      :class="{'is-green': $store.isCalculationSaved }"
      class="ec-calculation-name"
      @click="changeCalculationName">
      {{ ($store.isCalculationSaved) ? $store.calculationName : 'nicht gespeichert' }}</span>
    </div>
    <div 
      v-show="$store.isCalculationSaved"
      class="ec-calculation-id">ID: <span v-text="publicId"/>
    </div>
  </div>
</template>
<script>
    export default {
        name: "CalculationInfo",
        props: {
            'name': {
                type: String,
                required: true
            },
            'publicId': {
                type: String,
                required: true
            }
        },
        methods: {
            changeCalculationName() {
                this.$event.$emit('change-calculation-name')
            },
            setFreeForChanges() {
                this.$event.$emit('call-change-warning-modal')
            }
        }
    }
</script>